export default __webpack_public_path__ + "static/theperfectblack-a1ef61040b86e6192956c133aeac7024.png";